import type { ExternalInvoiceData } from '@festina/moneyin-general-types/moneyin'
import { InvoicesService } from '@festina/moneyin-general-types/moneyin/services/InvoicesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = InvoicesService.invoicesServicePostCreateExternalInvoice

export const useCreateExternalInvoice = ({ tenantId }: { tenantId: string }) =>
  useFestinaMutation({
    component: 'moneyIn',
    roles: InvoicesService.invoicesServicePostCreateExternalInvoice_roles,
    isScenario: false,
    mutateFunction: async (arg: ExternalInvoiceData) => {
      await method({ xTenantId: tenantId, requestBody: arg })
    },
  })
